<template>
  <div class="dlrBottom-guide">
    <div class="dlrBottom-guide-header flex">
      <div class="dlrBottom-guide-portrait" @click="changeMuted">
        <div class="dlrBottom-portrait-bg">
          <div class="dlrBottom-portrait-pic">
            <div class="dlrBottom-portrait-pic-box">
              <img src="@/assets/img/pic/woman-default-blue.png" alt="">
            </div>
          </div>
        </div>
        <div class="dlrBottom-guide-voice">
          <em :class="muted ? 'off' : 'on'"></em>
        </div>
      </div>
      <div class="dlrBottom-guide-nav" style="height:1.1rem" >
        <ul class="flex" v-show="false">
          <li v-for="(item,key) in navList" :key="key" @click="iCur=item.id" :class="{current:iCur==item.id}">
            <a class="flex " href="javascript:void(0);">
              <span>{{item.name}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="dlrBottom-guide-quit" @click="handleOffGuide">
        <p class="flex">
          <em class="icon-quit"></em>
          <span>退出</span>
        </p>
      </div>
    </div>
    <div class="dlrBottom-guide-body">
      <div class="dlrBottom-guide-section flex">
        <p>{{ audioContent && audioContent.wordsContent }}</p>
        <a class="flex" href="javascript:void(0);" v-show="false">
          <span>重听</span>
        </a>
      </div>
      <div class="dlrBottom-guide-coupon" v-show="isSHowActivityAndPacket">
        <ul class="flex">
          <li v-if="activitys.length && hasRedPacket">
            <div class="dlrBottom-guide-coupon-item flex">
              <div class="dlrBottom-guide-coupon-left">
                <div class="dlrBottom-guide-coupon-name">
                  <p>{{ activitys[0].title }}</p>
                </div>
              </div>
              <div class="dlrBottom-guide-coupon-right flex" @click="eventRegistration(activitys)">
                <a href="javascript:void(0)" class="flex">
                  <span>报名</span>
                </a>
              </div>
            </div>
          </li>
          <li v-if="activitys.length && hasRedPacket">
            <div class="dlrBottom-guide-coupon-item flex">
              <div class="dlrBottom-guide-coupon-left">
                <div class="dlrBottom-guide-coupon-name">
                  <p>{{ intendRedPacket && intendRedPacket.typeName }}</p>
                </div>
                <div class="dlrBottom-guide-coupon-price">
                  <p><ins>{{ intendRedPacket && intendRedPacket.money }}</ins><em>元</em></p>
                </div>
              </div>
              <div class="dlrBottom-guide-coupon-right flex" @click="getRedPacket">
                <a href="javascript:void(0)" class="flex">
                  <span>领取</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="dlrBottom-guide-coupon-only flex" v-if="!activitys.length && hasRedPacket && isSHowActivityAndPacket">
        <div class="dlrBottom-guide-only-left">
          <p><ins>{{ intendRedPacket && intendRedPacket.money }}</ins><em>元</em></p>
        </div>
        <div class="dlrBottom-guide-only-right">
          <div class="flex">
            <div class="dlrBottom-guide-only-info">
              <h3>{{ intendRedPacket && intendRedPacket.typeName }}</h3>
              <p>数量有限 先到先得</p>
            </div>
            <div class="dlrBottom-guide-only-btn" @click="getRedPacket">
              <a class="flex" href="javascript:void(0);">
                <span>领取</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="dlrBottom-guide-sales-only flex" v-if="activitys.length && !hasRedPacket && isSHowActivityAndPacket">
        <div class="dlrBottom-guide-sales-left">
          <div class="dlrBottom-guide-sales-name">
            <p>{{ activitys[0].title }}</p>
          </div>
        </div>
        <div class="dlrBottom-guide-sales-right" @click="eventRegistration(activitys)">
          <div class="dlrBottom-guide-only-btn">
              <a class="flex" href="javascript:void(0);">
                <span>报名</span>
              </a>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import "@/assets/scss/modules/BottomGuide.scss";
</style>
<script>
import { mapGetters } from 'vuex';
import layManager from '@/services/layer.manager';
import * as layerNames from '@/services/layerName';
import redPacketsProxy from '@/services/actionSync/red.packet.proxy';
import eventBus from '@/services/eventBus.service';
const navList = [{
  id:1,
  name:'店铺介绍'
},
{
  id:2,
  name:'车辆介绍'
},
{
  id:3,
  name:'优惠介绍'
}]
export default {
  data() {
    return {
      navList,
      iCur:1,
      offGuide: false,
      isSHowActivityAndPacket: false,
    }
  },
  props: {
    audioContent: {
      type: Object,
      default:null
    },
    muted: {
      type: Boolean,
      default:false
    },
  },
  inject: ['taskExecutor'],
  computed: {
    ...mapGetters({
      activitys: 'activitys',
      baseInfo: 'baseInfo',
      phoneCallStatus: 'phoneCall/phoneCallStatus',
    }),
    ...mapGetters('intended', {
      hasRedPacket: 'hasRedPacket',
      intendRedPacket: 'intendRedPacket'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
  },
  mounted () {
  },
  methods: {
    changeMuted () {
      eventBus.$emit('getMuted')
    },
    handleOffGuide(){
      this.offGuide = !this.offGuide
      this.$emit('handleOffGuide', this.offGuide);
      eventBus.$emit('toggleGuide', 'pause')
    },
    eventRegistration (activitys) {
      const activityId = activitys[0].id
      console.log('activityId',activitys,activityId);
      layManager.price(0, 0, 'znzt_dinglancuxiao_baoming_click', 2, activityId);
      eventBus.$emit('toggleGuide', 'pause')
    },
    getRedPacket () {
      redPacketsProxy.order({ isRemote: true });
      const seriesId= this.intendRedPacket && this.intendRedPacket.seriesId || 0;
      const elementId = this.phoneCallStatus ? '2|1211004|897|24487|205349|304290':'2|1211004|897|18491|205073|303809';
      layManager.open(layerNames.RED_PACKET_FORM_LAYER,
        {
          propsData: {
            dealerId: this.dealerId,
            promotionId: this.intendRedPacket.promotionId,
            redPacketsTypeId: this.intendRedPacket.typeId,
            seriesId: seriesId,
            elementId: elementId
          }
        });
        eventBus.$emit('toggleGuide', 'pause')
    },
  },
  watch: {
    audioContent: {
      handler: function (newVal) {
        if (newVal && newVal.code === 31) {
          this.isSHowActivityAndPacket = true
        }
      },
      immediate: true,
    },
  }
}
</script>
